module.exports = __webpack_public_path__ + "media/images/sections/collaboration-186ec2eba71816ba5132e5a32929c221.png";